import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=fe7100ca"
import script from "./AboutSection.vue?vue&type=script&scoped=true&lang=js"
export * from "./AboutSection.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=fe7100ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports